import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 64 64" x="0px" y="0px">
      <g>
        <path
          d="M60.9,29.4c0-0.5-0.5-0.8-1.3-0.8c0,0-6,0-6.3-0.3c-0.5-1.3-3.4-7.4-4.7-7.9c-1.6-0.5-5.6-1.6-7.7-2.1
 c0.8,1.1,0.5,2.9-0.3,3.9c1.6,0,3.5,0,6.4,1.8c2.1,2.9,3.2,6.6,3.4,9.2c0,0.3-15.8,1.1-19.4,1.1c0,0-19.7-1.1-19.7-1.3
 c0.8-1.3,3.4-7.4,5.8-9.2c2.4-1.8,3.2-1.8,5.6-1.8c-0.5-1.1-0.8-2.6,0-4.2c-1.1,0-6.9,1.8-8,2.9c-2.4,1.1-5.8,7.9-5.8,7.9h-5
 c-0.5,0-1.3,0.3-1.3,1.3v2.1c0,0.3,4.5,1.6,4.5,1.8c-0.5,1.1-2.1,6-2.4,7.9c-0.5,3.2-0.5,6.3,0,9.5C5,52.8,5.3,57.8,6,58.3
 c0.3,0.3,0.5,0.5,1.3,0.5h4.5c1.1,0,1.6-0.3,1.6-1.6v-3.2c0-0.3,0-0.5,0.5-0.5c1.1,0,34.1,0.3,37.5,0c0.3,0,0.5,0.3,0.5,0.5v3.4
 c0,1.1,0.5,1.3,1.6,1.3H58c0.3,0,0.5-0.3,0.5-0.3c0.3-0.3,1.6-7.4,1.6-8.9c0.5-3.4,0.3-6.8-0.5-10.2c-0.5-2.1-1.3-3.9-2.1-6
 c-0.3-0.3,3.7-1.3,3.7-1.3v-2.6C61.2,29.4,60.9,29.4,60.9,29.4z M12.1,45.7c-2.6,0-3.9-2.4-3.9-3.9c0-2.4,1.6-3.9,3.9-3.9
 c1.8,0,4.5,1.8,3.9,3.9C16.3,43.9,14.4,45.7,12.1,45.7 M51.7,45.7c-2.1,0-3.9-1.8-3.9-3.7c0-2.1,2.1-3.9,3.9-3.9
 c2.4,0.3,3.9,1.6,3.9,3.9C55.4,43.9,53.8,45.7,51.7,45.7"></path>
        <path
          d="M33.3,5v3c1.2,0,4.2,1.5,4.2,1.5l-1.5,3c0,0-2.7-1.2-4.5-1.2c-1.8,0-3,0.6-3.3,1.8c-0.3,0.6,0,1.2,1.2,2.1
 c1.2,0.9,3,0.6,5.1,1.2c2.1,0.6,3.6,2.7,3.6,5.1c0,2.7-2.4,5.1-5.1,5.1c0,0.3,0,3,0,3h-3.3v-3c-2.4,0-4.8-2.7-4.8-2.7l1.2-2.7
 c0,0,2.1,2.1,5.1,2.1c2.1,0,3.3-0.6,3.3-1.8c0-0.9,0-1.8-2.1-2.1c-1.5-0.6-3.9-0.9-5.1-2.1c-1.5-0.9-2.4-2.1-2.4-4.5
 c0-3,2.1-5.1,5.1-5.1v-3L33.3,5z"></path>
      </g>
    </svg>
  );
};

export default Icon;
